import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Base_URL } from "../../../actions/API_endpoint";

const CreateGallery = () => {
    const navigate = useNavigate();
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await axios.post(`${Base_URL}/api/galleries`, {
                name,
                description
            });
            navigate("/admin/galleries");
        } catch (error) {
            console.error("Error creating gallery:", error);
            alert("Error creating gallery: " + (error.response?.data?.error || error.message));
        }
    };

    return (
        <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white/5 backdrop-blur-2xl border border-white/20 text-white">
            <div className="rounded-t mb-0 px-6 py-6 border-b border-white/20">
                <div className="text-center flex justify-between">
                    <h6 className="text-white text-xl font-bold">Create New Gallery</h6>
                </div>
            </div>
            <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
                <form onSubmit={handleSubmit} className="mt-6">
                    <div className="flex flex-wrap">
                        <div className="w-full px-4">
                            <div className="relative w-full mb-3">
                                <label className="block uppercase text-blueGray-300 text-xs font-bold mb-2">
                                    Gallery Name (Unique)
                                </label>
                                <input
                                    type="text"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    className="border-0 px-3 py-3 placeholder-blueGray-400 text-white bg-white/10 rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150 border border-white/20"
                                    required
                                />
                            </div>
                        </div>
                        <div className="w-full px-4">
                            <div className="relative w-full mb-3">
                                <label className="block uppercase text-blueGray-300 text-xs font-bold mb-2">
                                    Description
                                </label>
                                <textarea
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                    rows="4"
                                    className="border-0 px-3 py-3 placeholder-blueGray-400 text-white bg-white/10 rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150 border border-white/20"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="flex justify-center mt-6">
                        <button
                            className="bg-lightBlue-600 text-white active:bg-lightBlue-700 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 border border-white/20"
                            type="submit"
                        >
                            Create Gallery
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CreateGallery;
